/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { LaunchDarklyError } from "./launchdarklyerror.js";

export type ForbiddenErrorRepData = {
  /**
   * Specific error code encountered
   */
  code: string;
  /**
   * Description of the error
   */
  message: string;
};

export class ForbiddenErrorRep extends LaunchDarklyError {
  /**
   * Specific error code encountered
   */
  code: string;

  /** The original data that was passed to this error instance. */
  data$: ForbiddenErrorRepData;

  constructor(
    err: ForbiddenErrorRepData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.code = err.code;

    this.name = "ForbiddenErrorRep";
  }
}

/** @internal */
export const ForbiddenErrorRep$inboundSchema: z.ZodType<
  ForbiddenErrorRep,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ForbiddenErrorRep(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ForbiddenErrorRep$Outbound = {
  code: string;
  message: string;
};

/** @internal */
export const ForbiddenErrorRep$outboundSchema: z.ZodType<
  ForbiddenErrorRep$Outbound,
  z.ZodTypeDef,
  ForbiddenErrorRep
> = z.instanceof(ForbiddenErrorRep)
  .transform(v => v.data$)
  .pipe(z.object({
    code: z.string(),
    message: z.string(),
  }));
